import { AgentAvailabilityState, AppState } from '@bd/agent/types'
import { Module } from 'vuex'
import { actions } from './actions'
import { mutations } from './mutations'
import { state } from './state'

const offers: Module<AgentAvailabilityState, AppState> = {
  namespaced: true,
  state,
  mutations,
  actions,
}

export default offers
